<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>Update Copay Fee Content</span>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="copayFeeTextForm" style="width: 100%;">

          <div class="content" fxLayout="column" fxLayoutGap="8px">
            <fxLayout fxLayout="column" fxLayout.gt-md="column" fxLayoutGap.gt-md="24px" style="margin-bottom: 20px; width: 100% !important;">
              <mat-label><b>Copay Fee Text</b></mat-label>
              <ckeditor [config]="editorConfig" formControlName="copayFeeText" debounce="500"></ckeditor>
              <mat-error
              *ngIf="copayFeeTextForm.controls['copayFeeText'].touched && copayFeeTextForm.controls['copayFeeText'].hasError('required')" style="font-size:13px;">
              This is a required field.</mat-error>
            </fxLayout>
              
          </div>

          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
          
            <button mat-button type="button" class="sub-button" (click)="saveCopayFee()"><span>Update Content</span></button>
          </div>
            <!-- <div class="row flxfrmsec">
              <div class="col-12 frmsec" style="width: 100%;">
              
  
                <div class="itemfrmflx" style="width: 100% !important; max-width: 100% !important;margin-top: 20px;">
                    <div class="form-fld text-center">
                      <div class="actionControl mr-2">
                        <button type="button" class="submit-btn" (click)="addContent()"><span>Update Content</span></button>
                      </div>
                    </div>
                  </div>
              </div>
            </div> -->
          </form>
    </div>
  </div>
